<template>
  <div v-if="newValue" class="quantity-selection--item">
    <select @change="change" class="quantity-selection--select notranslate" :name="item.value" :id="item.value" :class="{'is-selected': this.newValue > 0}">
      <option value="-1">{{item.name}}: {{newValue}}</option>
      <option v-for="number in selectRange" :key="number -1" :value="number -1">
        {{number - 1}}
      </option>
    </select>
  </div>
</template>
<script>

const defaultStartValue = '0'
export default {
  props: ['item', 'value'],
  data(){
    return{
      selectRange: 10,
      newValue: defaultStartValue
    }
  },
  mounted(){
    this.init()
  },
  methods: {
    init(){
      if(this.value) {
        let value = this.value[this.item.value]
        if(value){
          this.newValue = this.value[this.item.value]
        }
      }
    },
    change(event){
      let value = event.target.value
      this.newValue = value
      this.$emit('change', this.item.value, this.newValue)
      event.target.value = -1
    },
    reset() {
      if(this.value) {
        let value = this.value[this.item.value]
        if(value){
          this.newValue = this.value[this.item.value]
        } else {
          this.newValue = defaultStartValue
        }
      }
    }
  },
  computed: {
    itemValue(){
      if(this.newValue){
        return this.newValue
      }
      return "0"
    }
  },
  watch: {
    value: {
      handler(){
        this.reset()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.quantity-selection--content {
  margin-bottom: 20px;
}
.quantity-selection--item{
  width:  100%;
  height: 40px;
  position: relative;
  margin-bottom: 10px;
  &:after {
    font-family: 'yule-icon-set';
    content: '\E930';
    align-items: center;
    display: inline-flex;
    justify-content: center;
    position: absolute;
    right: 20px;
    font-size: 1.1em;
    pointer-events: none;
    height: 38px;
    line-height: 38px;
  }
}
.quantity-selection--select{
  appearance: none;
  width: 100%;
  height: 40px;
  background-color: white;
  border: 2px solid $paper;
  color: $ink-dark;
  border-radius: 3px;
  transition: all .15s ease-out;
  margin-bottom: 10px;
  padding-left: 15px;
  font-size: 16px;
  &::placeholder {
    color: $ink-dark;
  }
  &:hover {
    background-color: $paper-dark;
    border: 2px solid $paper-dark;
  }
  &:active {
    background-color: #ffffff;
    border: 2px solid $sensual;
  }
  &:focus {
    background-color: #ffffff;
    border: 2px solid $sensual;
  }
  &.is-selected {
    background-color: $paper-dark;
    border: 2px solid $paper-dark;
  }
}
</style>



// WEBPACK FOOTER //
// QuantitySelectionItem.vue?9902e46e